module.exports = __webpack_public_path__ + "img/income.79bda743.svg";